<template>
    <div :class="containerClass">
        <label :for="id" class="fw-bold" :style="labelStyle">
            {{ label }}
            <span v-if="required" class="required-fields">*</span>
        </label>
        <div class="checkbox-group">
            <label v-for="option in options" :key="option.value" class="checkbox-label">
            <input
                type="checkbox"
                :id="id + '_' + option.value"
                :name="name"
                :value="option.value"
                :checked="modelValue.includes(option.value)"
                @change="updateValue($event, option.value)"
                :disabled="disabled"
                class="checkbox-input me-2"
            />
            {{ option.text }}
            </label>
        </div>
        <span v-if="required && modelValue.length === 0" class="text-danger mt-1" :style="errorMsgStyle">
            {{ errorMessage }}
        </span>
    </div>
</template>
  
<script>
export default {
    name: "BaseCheckbox",
    props: {
        label: {
            type: String,
            default: "Select options",
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
        id: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: "This field is required",
        },
        labelStyle: {
            type: Object,
            default: () => ({
                fontSize: '14px',
            }),
        },
        errorMsgStyle: {
            type: Object,
            default: () => ({
                fontSize: '12px',
            }),
        },
    },
    computed: {
        containerClass() {
            return "col-md-3 mt-3";
        },
    },
    methods: {
        updateValue(event, value) {
            const newValue = [...this.modelValue];
            if (event.target.checked) {
                newValue.push(value);
            } else {
                const index = newValue.indexOf(value);
                if (index > -1) {
                    newValue.splice(index, 1);
                }
            }
            this.$emit('update:modelValue', newValue);
        },
    },
};
</script>
  
<style scoped>
.required-fields {
    color: red;
}
.checkbox-group {
    margin-top: 10px;
}
.checkbox-label {
    display: flex;
    align-items: center;
    margin-right: 15px;
}
.checkbox-input {
    margin-right: 5px;
}
</style>
  